{
  "primer": {
    "eyebrow": "Horarios de oración y Qibla",
    "headline": "Rhemn necesita tu ubicación para los horarios de oración y la Qibla.",
    "body": "La usamos para tus horarios de oración, la dirección de la Qibla y el clima local — nada más.",
    "cta": "Continuar",
    "skip": "Ahora no",
    "skip_body": "Los horarios de oración y la Qibla seguirán desactivados."
  }
}
